import { permanentRedirect, redirect } from 'next/navigation';

import { getProductAnimco } from '@services/animco';
import { cmsService } from '@services/cms';
import { logger } from '@services/loggers';
import { productDetailsService } from '@services/products/product-details';

import { PalpatineProduct } from '@app-types/api/palpatine';
import { WallType } from '@app-types/config';
import { ProductNotFoundError } from '@app-types/error';
import { SearchParamsType } from '@app-types/page';
import { ProductParentFull } from '@app-types/product';
import { SalesWallType } from '@app-types/sales';

import { PAGE_SLUG } from '@helpers/partials';
import { paths } from '@helpers/path';

import { getCurrentProduct, handleProductNotFound } from '@product-detail/helpers';

import { ProductDetail } from './product-detail';

interface SalesPhoneDetailsProps {
    params: { slug: string };
    searchParams?: SearchParamsType;
}

export async function SalesPhoneDetails({ params, searchParams }: Readonly<SalesPhoneDetailsProps>) {
    let product: ProductParentFull | undefined;
    let productStatics: PalpatineProduct[];
    const { slug } = params;
    const type = WallType.SALES_PHONE;

    try {
        [product, { items: productStatics }] = await Promise.all([
            productDetailsService.getProductDetails(type, params.slug),
            cmsService.getProduct(),
        ]);
    } catch (error) {
        const wallPath = paths.sales(SalesWallType.PHONE);
        if (error instanceof ProductNotFoundError) {
            logger.log('🚨 Phone not found', slug);
            const redirectInfo = handleProductNotFound(slug, WallType.PHONE, wallPath);
            permanentRedirect(redirectInfo.path);
        }
        redirect(wallPath);
    }

    const { product: productWithStock, currentProduct } = await getCurrentProduct(product, params.slug);

    const animco = getProductAnimco(productStatics, product.urlKey, false);
    animco.banner = [
        {
            hasDisplaySticker: true,
            stickerValue: 'BON PLAN',
            text: `Ce smartphone à prix préférentiel grâce aux Forfaits Bouygues Telecom. [En profiter](${paths.phoneDetail(slug)})`,
            isInverted: false,
            tracking: 'J_en_profite_prix_preferentiel',
        },
    ];

    return (
        <ProductDetail
            type={type}
            baseUrl={paths.sales(SalesWallType.PHONE)}
            searchParams={searchParams}
            product={productWithStock}
            currentProduct={currentProduct}
            animco={animco}
            enableKonami
            slug={PAGE_SLUG.PHONE_PRODUCT}
            easyTradeInEnabled={false}
        />
    );
}
